import Grid from '@material-ui/core/Grid'
import React, { FC } from 'react'
import { RichTextWrapper } from '../../../../styles/global'

//* utils
import { renderRichText } from '../../../../utils/richTextHandler.utils'
import formatInlineCode from '../../../../utils/shortTextFormatting'

//* components
import Button from '../../button'
import Typography from '../../typography'

type Props = {
  verticalTabData: any
  tabs: any
  goToSlide: any
}

export const VerticalMenu: FC<Props> = ({ verticalTabData, tabs, goToSlide }) => {
  return (
    <Grid className="VerticalTabs__Menu" item xs={12} sm={12} md={4}>
      <ul ref={(tab: any) => (tabs.current = tab)}>
        {verticalTabData.panels.map((item: any, idx: number) => {
          return (
            <li
              {...(idx === 0 && {
                className: 'VerticalTabs__Active--Desktop',
              })}
              key={`VerticalTabs__Menu-${idx}`}
              onClick={() => goToSlide(idx)}>
              {item.title && (
                <Typography className="VerticalTabs__Label" type="label">
                  {formatInlineCode(item.title)}
                </Typography>
              )}

              {item.body && (
                <div className="VerticalTabs__Accordion-Item">
                  <RichTextWrapper $type="body" className="VerticalTabs__Item-Body">
                    {renderRichText(item.body)}
                  </RichTextWrapper>

                  {item.cta && item.cta.externalUrl && item.cta.text && (
                    <Button
                      icon={true}
                      href={item.cta.externalUrl}
                      text={item.cta.text}
                      type="text-link"
                      size="small"
                      theme="light"
                    />
                  )}
                </div>
              )}
            </li>
          )
        })}
      </ul>
    </Grid>
  )
}
